import React from 'react';



export const Arrow = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="chatHelp-card-XA3-item-grid-link-arrow" role="presentation" aria-label="" padding={padding} viewBox="0 0 36 31" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="black" fillRule="evenodd">
<g>
<polygon points="10.53 16.52 9.47 15.46 12.94 11.99 9.47 8.53 10.53 7.46 15.06 11.99 10.53 16.52"/></g>
</g>
</svg>
);
